import { render, staticRenderFns } from "./WeetPlayerAnnotations.vue?vue&type=template&id=4ef48a9c&scoped=true"
import script from "./WeetPlayerAnnotations.vue?vue&type=script&lang=ts"
export * from "./WeetPlayerAnnotations.vue?vue&type=script&lang=ts"
import style0 from "./WeetPlayerAnnotations.vue?vue&type=style&index=0&id=4ef48a9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef48a9c",
  null
  
)

export default component.exports